import React from 'react'
import { TPost } from '../../../../../types/Post';
import s from './PollItems.module.scss';
import { ReactComponent as PollVs } from '../../../../assets/Vs.svg';

export const PollItems = ({ post, }: { post: TPost }): React.ReactElement => {
    const pollPostItems = [
        {
            img: post.item1?.img,
            itemTitle: post.item1?.title,
        },
        {
            img: post.item2?.img,
            itemTitle: post.item2?.title,
        },
    ]

    return (
        <>
            <div className={s.pollPostContainer}>
                <PollVs className={s.vsIcon} />
                {pollPostItems.map(item =>
                    <div className={s.pollItemContainer} key={item.itemTitle}>
                        <img
                            src={item.img}
                            className={s.pollItemImg}
                            alt="poll-item"
                        />
                        <span className={s.itemTitle}>
                            {item.itemTitle}
                        </span>
                    </div>
                )}
            </div>
        </>
    )
}